<template>
   <app-parser_wrapper  :init="init">    </app-parser_wrapper>
</template>

<script>
 export default {

     data () {
       return {
   init: {
     menu:{
       items: [
       {
           id:"8.1",
           title:"Страницы",
           objName: "pages",
           dataType:"pages",
           form: [
             {
               type:'info',
               vModel: {contentType:'pages',value:''},
               vkapi: false,
             },
             {
               type:'procBinding',
               name: 'Список сообществ',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active:false,
                 },
                 procUpdatesLabel: "Обновления процессов как список страниц",
                 contentType: 'pages',

               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.pages,
               label: 'Использовать запомненные страницы: '+ this.$store.state.memory.pages ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               memoryType: 'pages',
               dataType: 'memory',
             },
           {
             type:'textarea',
             name: 'Список страниц',
             vModel: {name:'pagesList',value:''},
             vkapi: false,
             dataType: 'list'
           },
           {
             type:'select',
             name: 'Пол',
             options: [{text:'Любой',value:''},{text:'Женский',value:'1'},{text:'Мужской',value:'2'} ],
             vModel: {name:'sex',value:''},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type:'select',
             name: 'Тип профиля',
             options: [{text:'Любой',value:''},{text:'Открытый',value:'0'},{text:'Закрытый',value:'1'} ],
             vModel: {name:'isClosed',value:''},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'checkboxMultir',
             name: 'Параметры статуса',
             vModel: {name:'status',value:true},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'input',
             name: 'Подписчиков не менее чем',
             vModel: {name:'followersCountMin',value:''},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'input',
             name: 'Подписчиков не более чем',
             vModel: {name:'followersCountMax',value:''},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'input',
             name: 'Возраст не менее чем',
             vModel: {name:'ageMin',value:''},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'input',
             name: 'Возраст не более чем',
             vModel: {name:'ageMax',value:''},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'checkbox',
             name: 'Мобильный телефон',
             vModel: {name:'cellPhone',value:''},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'checkbox',
             name: 'Личный сайт',
             vModel: {name:'site',value:''},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'checkbox',
             name: 'Открытые сообщения',
             vModel: {name:'canWritePrivateMessage',value:''},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'checkbox',
             name: 'Добавление в друзья',
             vModel: {name:'canSendFriendRequest',value:''},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'checkbox',
             name: 'Открытая стена',
             vModel: {name:'canPost',value:''},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'checkbox',
             name: 'Онлайн',
             vModel: {name:'online',value:''},
             vkapi: false,
             dataType: 'FormParams'
           },
           {
             type: 'datePicker',
             name: 'Последний вход не позднее чем',
             vModel: {name:'lastSeenFrom',value:''},
             vkapi: false,
             dataType: 'FormParams',
             modal: false
           },
           {
             type: 'datePicker',
             name: 'Последний вход  не ранее чем',
             vModel: {name:'lastSeenTo',value:''},
             vkapi: false,
             dataType: 'FormParams',
             modal: false
           },
           ],
       },
         {
           id:"8.2",
           title:"Группы",
           objName: 'groups',
           dataType:"groups",
           form: [
             {
               type:'info',
               vModel: {contentType:'groups',value:''},
               vkapi: false,
             },
             {
               type:'procBinding',
               name: 'Список сообществ',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active: false,
                 },
                 procUpdatesLabel: "Обновления процессов как список сообществ",
                 contentType: 'groups',

               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.groups,
               label: 'Использовать запомненные сообщества: '+ this.$store.state.memory.groups ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               memoryType: 'groups',
               dataType: 'memory',
             },
             {
               type:'textarea',
               name: 'Список сообществ',
               vModel: {name:'groupsList',value:''},
               vkapi: false,
               dataType: 'list'
             },

             {
               type:'select',
               name: 'Тип сообщества',
               options: [{text:'Сообщество',value:'group'},{text:'Страница',value:'page'},{text:'Встреча',value:'event'}  ],
               vModel: {name:'type',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type:'input',
               name: 'Участников минимум',
               vModel: {name:'flMin',value:''},
               vkapi: false,
               dataType: 'FormParams'

             },
             {
               type: 'input',
               name: 'Участников максимум',
               vModel: {name:'flMax',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'checkbox',
               name: 'Оставить только сообщества активности',
               vModel: {name:'minusActivitiClubs',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'checkbox',
               name: 'Исключить сообщества активности',
               vModel: {name:'minusActivitiClubs',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'checkbox',
               name: 'Исключить сообщества черного списка',
               vModel: {name:'minusActivitiClubs',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'checkbox',
               name: 'Только скрытые подписчики',
               vModel: {name:'closedMembers',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'checkbox',
               name: 'Только открытые подписчики',
               vModel: {name:'openMembers',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'checkbox',
               name: 'Закрытое сообщество',
               vModel: {name:'closedComunity',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'checkbox',
               name: 'Открытое сообщество',
               vModel: {name:'openComunity',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'checkbox',
               name: 'Частное сообщество',
               vModel: {name:'privateComunity',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'checkbox',
               name: 'Открытая стена',
               vModel: {name:'openWall',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'checkbox',
               name: 'Сообщения сообщества',
               vModel: {name:'messages',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'checkboxMulti',
               name: 'Семантика описания',
               dialogLabel: "Семантика описания",
               dialogOpen: false,
               vModel: {name:'descSemantic',value:false},
               descSemanticParams: {
                 wordsPlus : {
                   items: [],
                   selected: [],
                 },
                 wordsMinus :  {
                   items: [],
                   selected: [],
                 },
                 hasPhone: null,
                 hasSite:null,
                 hasEmail:null,



               },
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'checkboxMulti',
               name: 'Семантика и параметры  постов',
               dialogLabel: "Параметры постов в сообществе",
               dialogOpen: false,
               vModel: {name:'postSemantic',value:false},
               postSemanticParams: {
                 postCount: 25,
                 offset:'0',



                 authorsMin: null,
                 authorsMax: null,
                 viewsMin : null,
                 viewsMax : null,
                 likesMin : null,
                 likesMax : null,
                 commentsMin : null,
                 commentsMax : null,
                 repostsMin : null,
                 repostsMax : null,

                 likeToViewMin : null,
                 likeToViewMax : null,

                 wordsPlus : "",
                 wordsMinus : "",
                 regPlus : "",
                 regMinus : "",


               },
               vkapi: false,
               dataType: 'FormParams'
             },

           ]
         },
         {
           id:"8.3",
           title:"Обсуждения",
           objName: 'topics',
           dataType:"topics",
           form:  [
             {
               type:'info',
               vModel: {contentType:'topics',value:''},
               vkapi: false,
             },
             {
               type:'procBinding',
               name: 'Список обсуждений',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active: false,
                 },
                 procUpdatesLabel: "Обновления процессов как список обсуждений",
                 contentType: 'topics',

               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.topics,
               label: 'Использовать запомненные обсуждения: '+ this.$store.state.memory.topics ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               memoryType: 'topics',
               dataType: 'memory',
             },
             {
               type:'textarea',
               name: 'Список обсуждений',
               vModel: {name:'topicsList',value:''},
               vkapi: false,
               dataType: 'list'
             },

             {
               type: 'input',
               name: 'Минимум комментариев',
               vModel: {name:'commentsMin',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'input',
               name: 'Максимум комментариев',
               vModel: {name:'commentsMax',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'datePicker',
               name: 'Созданн не ранее чем',
               vModel: {name:'publishedFrom',value:''},
               vkapi: false,
               dataType: 'FormParams',
               modal: false
             },
             {
               type: 'datePicker',
               name: 'Созданн не позднее чем',
               vModel: {name:'publishedTo',value:''},
               vkapi: false,
               dataType: 'FormParams',
               modal: false
             },
             {
               type: 'datePicker',
               name: 'Обновлен не ранее чем',
               vModel: {name:'updatedFrom',value:''},
               vkapi: false,
               dataType: 'FormParams',
               modal: false
             },
             {
               type: 'datePicker',
               name: 'Обновлен не позднее чем',
               vModel: {name:'updatedTo',value:''},
               vkapi: false,
               dataType: 'FormParams',
               modal: false
             },
           ]

       },
         {
           id:"8.4",
           title:"Видео",
           objName: 'videos',
           dataType:"videos",
           form:  [
             {
               type:'info',
               vModel: {contentType:'videos',value:''},
               vkapi: false,
             },
             {
               type:'procBinding',
               name: 'Список видео',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active: false,
                 },
                 procUpdatesLabel: "Обновления процессов как список видео",
                 contentType: 'videos',

               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.videos,
               label: 'Использовать запомненные видео: '+ this.$store.state.memory.videos ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               memoryType: 'videos',
               dataType: 'memory',
             },
             {
               type:'textarea',
               name: 'Список видео',
               vModel: {name:'videosList',value:''},
               vkapi: false,
               dataType: 'list'
             },

             {
               type: 'input',
               name: 'Минимум комментариев',
               vModel: {name:'commentsMin',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'input',
               name: 'Максимум комментариев',
               vModel: {name:'commentsMax',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'input',
               name: 'Минимум лайков',
               vModel: {name:'likesMin',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'input',
               name: 'Максимум лайков',
               vModel: {name:'likesMax',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'input',
               name: 'Минимум просмотров',
               vModel: {name:'viewsMin',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'input',
               name: 'Максимум просмотров',
               vModel: {name:'viewsMax',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'datePicker',
               name: 'Загруженно не ранее чем',
               vModel: {name:'publishedFrom',value:''},
               vkapi: false,
               dataType: 'FormParams',
               modal: false
             },
             {
               type: 'datePicker',
               name: 'Загруженно не позднее чем',
               vModel: {name:'publishedTo',value:''},
               vkapi: false,
               dataType: 'FormParams',
               modal: false
             },

           ]

         },
         {
           id:"8.5",
           title:"Фото",
           objName: 'photos',
           dataType:"photos",
           form:  [
             {
               type:'info',
               vModel: {contentType:'photos',value:''},
               vkapi: false,
             },
             {
               type:'procBinding',
               name: 'Список фото',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active: false,
                 },
                 procUpdatesLabel: "Обновления процессов как список фото",
                 contentType: 'photos',

               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.photos,
               label: 'Использовать запомненные фото: '+ this.$store.state.memory.photos ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               memoryType: 'photos',
               dataType: 'memory',
             },
             {
               type:'textarea',
               name: 'Список фотографий',
               vModel: {name:'photosList',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },

             {
               type: 'input',
               name: 'Минимум комментариев',
               vModel: {name:'commentsMin',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'input',
               name: 'Максимум комментариев',
               vModel: {name:'commentsMax',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'input',
               name: 'Минимум лайков',
               vModel: {name:'likesMin',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'input',
               name: 'Максимум лайков',
               vModel: {name:'likesMax',value:''},
               vkapi: false,
               dataType: 'FormParams'
             },

             {
               type: 'datePicker',
               name: 'Загруженно не ранее чем',
               vModel: {name:'publishedFrom',value:''},
               vkapi: false,
               dataType: 'FormParams',
               modal: false
             },
             {
               type: 'datePicker',
               name: 'Загруженно не позднее чем',
               vModel: {name:'publishedTo',value:''},
               vkapi: false,
               dataType: 'FormParams',
               modal: false
             },

           ]

         },
       ],
     },
    title:{
      first: 'Результат фильтра:'
    },

    searchLoop:{
      active:false,
      placeholder:'Введите имя через запятую'
    },

    beforeSearch:{
      title: 'Тут будет отображен результат фильтра',
      activator: true,
      activatorName: 'Начать фильтр'
    },


    network:{

      contentType: "pages",
      processName: 'filter',
      dataType: 'pages',
      actionsFile:  'http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/filter/filter.php'
    },




    contentMenegment: {
      marginTop: '0px',
      items: {
        selector: {active:true},
        copy: {active:true},
        export: {active:true},
        update: {active:false},
        delete: {active:false},
        autoExport: {active:false}
      },
      contentInfo: {
        type: 'pages',
      },
       autoExport: {
         isActive: false,
         tasksList:[],
       }
     },
     progressСircular: false,
   }


       }
     },

     created(){

   this.init.forma = this.init.firstForma
     },
   }
</script>


<style>

</style>
